export const encodeArrayFormField = (items, mapFn) =>
  JSON.stringify(items.map(value => mapFn(value)));
